<section class="grafico">
    <article [class.escuro]="isEscuro">
      <div class="barras">
        <virtual-scroller #scroll [items]="indices" [horizontal]="true" [enableUnequalChildrenSizes]="true"
                          (vsChange)="getChange($event)">
          <ng-container *ngFor="let poluente of scroll.viewPortItems; let i = index">
            <div class="barra" *ngIf="!poluente.divisoria">
              <div class="poluente" [class.atual]="scroll.viewPortItems.length - 1 == i">
                <div *ngIf="!poluente.stDadoValidado" class="balao">
                  <p>--</p>
                </div>
                <div *ngIf="poluente.stDadoValidado" class="balao">
                  <p>{{poluente.indiceQualidadeAr | iqar:poluente.codigo}}</p>
                </div>
                <div class="triangulo"></div>
              </div>
              <div *ngIf="!poluente.stDadoValidado" class="progresso classificacao-0" [style.height.px]="poluente.valor"></div>
              <div *ngIf="poluente.stDadoValidado" class="progresso classificacao-{{poluente.classificacaoIqAr.id}}"
                   [style.height.px]="poluente.valor"></div>
              <p class="hora">{{poluente.dtMedicao | date:'HH:mm'}}</p>
              <p class="data-barra">
                {{i != 0 ? '&nbsp;' : poluente.dtMedicao | date:'dd/MM/yyyy'}}
              </p>
            </div>
            <div class="barra" *ngIf="poluente.divisoria">
              <div class="divisoria"></div>
              <p class="data-divisoria">
                {{poluente.dtMedicao | date:'dd/MM/yyyy'}}
              </p>
            </div>
          </ng-container>
        </virtual-scroller>
      </div>
    </article>
  </section>
  <div class="setas">
    <div>
      <ion-icon *ngIf="!start" name="arrow-back-outline"></ion-icon>
    </div>
    <div>
      <ion-icon  *ngIf="!end" name="arrow-forward-outline"></ion-icon>
    </div>
  </div>

